const translations = {
  de: {

    welcome: {
      title: "Willkommen bei Restroom Advisor!",
      subtitle: "Finde die besten öffentlichen Toiletten in deiner Stadt",
      nameLabel: "Dein Name",
      namePlaceholder: "z.B. Max Mustermann",
      startButton: "Los geht's!",
      cityLabel: "In welcher Stadt befindest du dich?",
      cityPlaceholder: "z.B. Berlin, München, Hamburg",
      locationButton: "Meinen Standort nutzen",
      locationDetecting: "Erkenne Standort...",
      orDivider: "oder",
      minCharsHint: "💡 Tippe mindestens 3 Buchstaben für Vorschläge",
      noCitiesFound: "Keine Städte gefunden für",
      tryDifferentSpelling: "Versuche eine andere Schreibweise",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      nutzungsbedingungen: "Nutzungsbedingungen",
      charactersCount: '{count}/30 Zeichen',  
      adminLogin: '🔐 Admin-Login', 
      adminEmail: 'Admin E-Mail', 
      adminPassword: 'Admin Passwort', 
      adminLoginButton: 'Admin Login',  
      cancel: 'Abbrechen', 
      nameStoredLocally: 'Dein Name wird lokal auf deinem Gerät gespeichert',
      guestButton: 'Als Gast fortfahren'
    },

    languageSelection: {
      title: "Sprache wählen",
      subtitle: "Choose Language",
      german: "Deutsch",
      english: "English",
      infoText: "Du kannst die Sprache später in deinem Profil ändern."
    },
    
    // App Download Screen (Web-Only)
    appDownload: {
      title: "Restroom Advisor",
      androidOnly: "Nur für Android verfügbar",
      description: "Lade die offizielle Restroom Advisor App herunter und erlebe alle Funktionen mit verbesserter Performance!",
      benefit1Title: "Deine Daten bleiben auf deinem Gerät",
      benefit1Text: "Name, Bewertungen und Check-ins nur lokal gespeichert",
      benefit2Title: "Offline-Funktionalität",
      benefit2Text: "Nutze die App auch ohne Internetverbindung",
      benefit3Title: "Bessere Performance",
      benefit3Text: "Schnellere Ladezeiten und flüssigere Bedienung",
      downloadButton: "Jetzt im Play Store laden",
      continueWeb: "Weiter mit Web-Version"
    },

    main: {
      searchToilet: "🚽 WC",
      searchCity: "🏙️ Stadt",
      infoBadgeOf: "von",
      infoBadgeShown: "Toiletten angezeigt",
      infoBadgeMove: "Verschiebe die Karte für mehr",
      filterAccessible: "♿ Zugang",
      filterFree: "💰 Gratis",
      toiletsFound: "Toiletten gefunden",
      toiletsFoundSingular: "Toilette gefunden",
      toiletsFoundPlural: "Toiletten gefunden",
      results: "Ergebnisse",
      resultsFor: "Ergebnis für",
      resultsForPlural: "Ergebnisse für",
      of: "von",
      gesamt: "gesamt",
      total: "gesamt",
      sichtbar: "sichtbar",
      imSichtbarenBereich: "im sichtbaren Bereich",
      navMap: "Karte",
      navList: "Liste",
      navSuggest: "Vorschlag machen",
      navProfile: "Profil",
      searchCityPlaceholder: "🏙️ Stadt suchen...",
      searchToiletPlaceholder: "🚽 Toilette suchen..."
    },

    listView: {
      closed: "Geschlossen",
      suggestion: "Vorschlag",
      timesReported: "x gemeldet",
      open: "Offen",
      review: "Bewertung",
      reviews: "Bewertungen",
      lastVisited: "Zuletzt besucht:",
      free: "Kostenlos",
      paid: "Kostenpflichtig",
      accessible: "Barrierefrei"
    },

    suggest: {
      title: "Toilette vorschlagen",
      infoText: "Dein Vorschlag wird in der Liste erscheinen und ist für alle sichtbar.",
      editingInfo: "Du bearbeitest eine bestehende Toilette. Änderungen werden sofort übernommen.",
      mandatoryFields: "Pflichtangaben",
      nameLabel: "Name der Toilette",
      namePlaceholder: "z.B. City Toilet Hauptbahnhof",
      selectPhoto: "Foto auswählen",
      addressLabel: "Adresse",
      addressPlaceholder: "Tippe mind. 3 Zeichen für Vorschläge...",
      addressHint: "Tippe mindestens 3 Zeichen für Vorschläge",
      addressTips: "Tipps: Tippe den vollständigen Straßennamen",
      addressExample: "z.B. \"Hunnentränke\" statt \"Hunnentr\"",
      searchingAddresses: "Suche Adressen...",
      noAddressesFound: "Keine Adressen gefunden für \"{query}\"",
      useCurrentLocation: "Meinen Standort nutzen",
      selectOnMap: "Auf Karte auswählen",
      selectedLocation: "Standort gewählt",
      tapToSelect: "Tippe auf die Karte, um den Standort zu markieren",
      markerCanBeMoved: "Der Marker kann anschließend durch erneutes Tippen verschoben werden",
      costLabel: "Kosten",
      costFree: "Kostenlos",
      costPaid: "Kostenpflichtig",
      costAmount: "Preis (z.B. 0,50€)",
      costAmountPlaceholder: "z.B. 0,50€",
      accessibilityLabel: "Barrierefrei?",
      accessibilityYes: "Ja",
      accessibilityNo: "Nein",
      accessibilityUnknown: "Unbekannt",
      openingHoursLabel: "Öffnungszeiten (optional)",
      openingHoursPlaceholder: "z.B. Mo-Fr 8-18 Uhr",
      amenitiesLabel: "Ausstattung (optional)",
      photosLabel: "Fotos hinzufügen (optional)",
      uploadPhotos: "Fotos hochladen",
      uploadHint: "Klicke hier oder ziehe Bilder hierher",
      photosSelected: "Foto(s) ausgewählt",
      submitButton: "Vorschlag absenden",
      editButton: "Änderungen speichern",
      editRestroom: "Toilette bearbeiten",
      mapTip: "Klicke auf die Karte, um den exakten Standort zu markieren. Die Adresse wird automatisch ermittelt und kann bei Bedarf angepasst werden.",
      newLocation: "Neuer Standort",
      detectingLocation: "Standort wird ermittelt...",
      additionalRequired: "Weitere Pflichtangaben",
      additionalInfo: "Weitere Informationen",
      initialReview: "Erste Bewertung",
      validation: {
      requiredFields: "Bitte Name, Adresse (oder Standort auf Karte) und Kosten angeben!",
      priceRequired: "Bitte Preis angeben!",
      confirmDifferentCity: "⚠️ Achtung: Der markierte Standort liegt in \"{sCity}\", aber du hast \"{city}\" als Stadt ausgewählt.\n\nMöchtest du trotzdem fortfahren?\n\nDie Toilette wird in \"{sCity}\" gespeichert."
      }
    },

    review: {
      title: "Bewerten oder Foto hochladen",
      editTitle: "Bewertung bearbeiten",
      commentLabel: "Dein Kommentar",
      commentPlaceholder: "Teile deine Erfahrungen... (optional)",
      charactersCount: "{count} Zeichen",
      addPhotos: "Fotos hinzufügen",
      importantReminder: "Wichtige Erinnerung",
      photoReminderText: "Bitte fotografiere nur die Toiletten-Ausstattung. Keine Personen dürfen auf den Fotos sichtbar sein (auch nicht im Hintergrund oder in Spiegeln).",
      uploadPhotos: "Fotos hochladen",
      uploadHint: "Klicke hier oder ziehe Bilder hierher",
      photosSelected: "{count} Foto(s) ausgewählt",
      confirmationText: "✅ Mit dem Absenden bestätigst du, dass deine Fotos die Foto-Richtlinien einhalten und keine Personen zeigen.",
      submitDisabled: "Bitte Sterne vergeben oder Fotos hochladen",
      pleaseRateOrUpload: "Bitte Sterne vergeben oder Fotos hochladen",
      submitPhotosOnly: "{count} Foto(s) hochladen",
      submitReview: "Bewertung absenden",
      updateReview: "Bewertung aktualisieren",
      rateYourVisit: "Wie war dein Besuch?",
      tapToRate: "Tippe auf die Sterne um zu bewerten",
      veryBad: "Sehr schlecht",
      bad: "Schlecht",
      okay: "Okay",
      good: "Gut",
      excellent: "Ausgezeichnet!"
    },

    validation: {
      allowedCharsComment: "✓ Erlaubt: Buchstaben, Zahlen, Emojis, Satzzeichen",
      maxCharacters: "✓ Max. {count} Zeichen",
      charactersRemaining: "{current}/{max} Zeichen"
    },

    reportClosure: {
      title: "Änderung melden",
      selectCategory: "Kategorie auswählen",
      selectReason: "Grund auswählen",
      additionalInfo: "Zusätzliche Informationen (optional)",
      additionalInfoPlaceholder: "z.B. Wann hast du die Änderung bemerkt?",
      addPhotos: "Fotos hinzufügen (optional)",
      photoProofHelp: "Fotos können als Nachweis für deine Meldung dienen",
      uploadPhotos: "Fotos hochladen",
      uploadHint: "Klicke hier oder ziehe Bilder hierher",
      photosSelected: "{count} Foto(s) ausgewählt",
      submitReport: "Meldung absenden",
      infoMessage: "ℹ️ Deine Meldung hilft der Community. Sie wird vom Admin-Team geprüft.",
      selectCategoryError: "Bitte wähle eine Kategorie aus!",
      selectReasonError: "Bitte wähle einen Grund aus!",
      categories: {
        closed: "🔒 Geschlossen",
        address: "📍 Falsche Adresse",
        hours: "🕐 Falsche Öffnungszeiten",
        accessibility: "♿ Barrierefreiheit falsch",
        cost: "💶 Kosten falsch",
        other: "📝 Sonstiges"
      },
      reasons: {
        closed: {
          temporary: "Temporär geschlossen",
          permanent: "Permanent geschlossen",
          notFound: "Nicht auffindbar",
          renovation: "Im Umbau",
          other: "Andere"
        },
        address: {
          wrong: "Adresse falsch",
          entrance: "Eingang woanders",
          notExists: "Gebäude nicht vorhanden",
          other: "Andere"
        },
        hours: {
          wrong: "Öffnungszeiten falsch",
          different: "Andere Öffnungszeiten",
          alwaysOpen: "Immer offen",
          alwaysClosed: "Immer geschlossen",
          other: "Andere"
        },
        accessibility: {
          notAccessible: "Nicht barrierefrei",
          accessible: "Barrierefrei",
          wheelchairAccessible: "Rollstuhlgerecht",
          other: "Andere"
        },
        cost: {
          wrongAmount: "Falscher Betrag",
          freeInsteadPaid: "Kostenlos statt kostenpflichtig",
          paidInsteadFree: "Kostenpflichtig statt kostenlos",
          other: "Andere"
        },
        other: {
          inappropriatePhoto: "Foto unangemessen",
          wrongName: "Name falsch",
          other: "Andere"
        }
      }
    },

    reportComment: {
      title: "Kommentar melden",
      commentBy: "Kommentar von",
      noText: "Kein Text",
      selectReason: "Warum meldest du diesen Kommentar?",
      reasons: {
        hate: "Beleidigung / Hassrede",
        spam: "Spam / Werbung",
        misinformation: "Falsche Informationen",
        inappropriate: "Unangemessener Inhalt",
        other: "Sonstiges"
      },
      warningText: "Falsche Meldungen können zu einer Sperrung führen."
    },

    detail: {
      details: "Details",
      closed: "Diese Toilette ist geschlossen",
      reason: "Grund",
      until: "Voraussichtlich bis",
      closedAt: "Geschlossen am",
      suggested: "Vorgeschlagene Toilette",
      suggestedBy: "Vorgeschlagen von",
      waitingForApproval: "Wartet auf Bestätigung",
      timesReported: "x gemeldet",
      address: "Adresse",
      city: "Stadt",
      cost: "Kosten",
      free: "Kostenlos",
      paid: "Kostenpflichtig",
      accessibility: "Zugänglichkeit",
      accessible: "Barrierefrei",
      notAccessible: "Nicht barrierefrei",
      openingHours: "Öffnungszeiten",
      nowOpen: "Jetzt geöffnet",
      currentlyClosed: "Aktuell geschlossen",
      amenities: "Ausstattung",
      lastVisited: "Zuletzt besucht",
      reviews: "Bewertungen",
      noReviews: "Noch keine Bewertungen. Sei der Erste!",
      rateButton: "Bewerten oder Foto hochladen",
      editReview: "Bewertung bearbeiten",
      reportChange: "Änderung melden",
      showOnMap: "Auf Karte anzeigen",
      navigation: "Navigation",
      addReview: "Bewertung hinzufügen", 
      comment: "Kommentar", 
      uploadPhoto: "Fotos hochladen", 
      yes: "Ja", 
      no: "Nein", 
      startNavigation: "Navigation starten",
      showDetails: "Details anzeigen",
      navigationModal: {
        title: "Navigation starten",
        externalAppRequired: "Externe App erforderlich",
        description: "Du wirst zu einer externen Navigations-App weitergeleitet (z.B. Google Maps, Apple Maps etc.).",
        reminder: "Stelle sicher, dass du eine Navigations-App installiert hast, um die Route zu starten.",
        dontShowAgain: "Diese Meldung nicht mehr anzeigen",
        cancel: "Abbrechen",
      startNavigation: "Navigation starten"
      },
      notSpecified: "Keine Angabe",
      reportedClosedTimes: "Diese Toilette wurde {count}x als geschlossen gemeldet",
      lastReport: "Letzte Meldung:"
    },

    profile: {
      myProfile: "Mein Profil",
      memberSince: "Mitglied seit",
      level: "Level",
      toiletsUntilNext: "Toiletten bis zum nächsten Level",
      maxLevel: "Max Level erreicht!",
      different: "Verschiedene",
      checkIns: "Check-ins",
      visitedToilets: "Besuchte Toiletten",
      noVisits: "Noch keine Toiletten besucht",
      timesVisited: "x besucht",
      achievements: "Achievements",
      achievementsUnlocked: "freigeschaltet",
      secret: "GEHEIM",
      adminDashboard: "Admin-Dashboard",
      saveButton: "Speichern",
      successSaved: "Name erfolgreich geändert!",
      nameTooShort: "Name muss mindestens 2 Zeichen lang sein",
      dangerZone: "Gefahrenzone",
      resetWarning: "Setze die App auf den Anfangszustand zurück. Alle deine Daten (Name, Check-ins, Bewertungen) werden unwiderruflich gelöscht.",
      resetButton: "App komplett zurücksetzen",
      resetConfirm1: "WIRKLICH ALLES LÖSCHEN?",
      resetConfirm2: "LETZTE WARNUNG!",
      resetSuccess: "App wurde zurückgesetzt!",
      languageSettings: "Spracheinstellungen",
      currentLanguage: "Aktuelle Sprache",
      changeLanguage: "Sprache ändern",
      editProfile: "Profil bearbeiten",
      yourName: "Dein Name",
      yourNamePlaceholder: "Dein Name",
      characters: "Zeichen",
      language: "Sprache",
      tapToChangeLanguage: "Tippe um die Sprache zu wechseln",
      visitedToiletAlt: "Vorschaubild der besuchten Toilette",
      changeNameButton: "Namen ändern",
      nameChangeSuccess: "✅ Name erfolgreich geändert!",
      nameMinLength: "Name muss mindestens 2 Zeichen lang sein",
      dangerZoneTitle: "⚠️ Gefahrenzone",
      resetDescription: "Setze die App auf den Anfangszustand zurück. <strong>Alle deine Daten</strong> (Name, Check-ins, Bewertungen) werden <strong>unwiderruflich gelöscht</strong>.",
      resetButtonText: "App komplett zurücksetzen",
      resetConfirmTitle1: "⚠️ WIRKLICH ALLES LÖSCHEN?",
      resetConfirmItems: "Dies löscht:\n• Deinen Namen\n• Alle Check-ins\n• Alle Bewertungen\n• Alle lokalen Daten\n\nDieser Vorgang kann NICHT rückgängig gemacht werden!",
      resetConfirmTitle2: "🚨 LETZTE WARNUNG!",
      resetConfirmFinal: "Bist du dir 100% sicher?\n\nKlicke OK um ALLES zu löschen.",
      resetSuccessMessage: "✅ App wurde zurückgesetzt!",
      citySwitchDisabled: "Du hast den automatischen Stadt-Wechsel-Dialog deaktiviert.",
      reEnableCitySwitchButton: "Stadt-Wechsel-Dialog wieder aktivieren",
      citySwitchReenabled: "✅ Stadt-Wechsel-Dialog wieder aktiviert!",
      selectRank: "Rank auswählen",
      currentRank: "Aktueller Rank",
      checkInRanks: "Check-In Ranks",
      reviewRanks: "Review Ranks",
      achievementRanks: "Achievement Ranks",
      specialRanks: "Spezial-Ranks",
      rankChanged: "✅ Rank geändert!",
      changeRank: "Ändern"
    },

    achievementPopup: {
      unlocked: "🏆 Achievement Freigeschaltet!",
      viewAll: "📊 Alle Achievements anzeigen"
    },

    loading: {
      title: "Lädt...",
      pleaseWait: "Bitte warten"
    },

    netiquette: {
      title: "Foto-Richtlinien",
      importantNotice: "ℹ️ Wichtig: Alle hochgeladenen Fotos werden einzeln geprüft",
      importantDescription: "Unser Admin-Team überprüft jeden Beitrag vor der Veröffentlichung, um die Qualität und Einhaltung der Richtlinien sicherzustellen.",
      rulesHeading: "Bitte beachte folgende Regeln beim Hochladen von Fotos:",
      noPeople: "Keine Menschen auf Fotos",
      noPeopleDesc: "Es dürfen <strong>keinerlei Personen</strong> auf den Fotos erkennbar sein. Achte darauf, dass keine Personen im Hintergrund, in Spiegeln oder anderweitig sichtbar sind.",
      privacyRights: "Persönlichkeitsrechte beachten",
      privacyRightsDesc: "Respektiere die Privatsphäre anderer. Keine Fotos von Personen beim Toilettengang oder in privaten Momenten.",
      onlyFacilities: "Nur Toiletten-Ausstattung fotografieren",
      onlyFacilitiesDesc: "Fotografiere ausschließlich die Toiletten-Einrichtung, Waschbecken, Sauberkeit und Ausstattung. Zeige wie die Toilette aussieht und ausgestattet ist.",
      confirmText: "<strong>Ich habe die Foto-Richtlinien gelesen und verstanden.</strong> Ich bestätige, dass auf meinen Fotos keine Personen zu sehen sind und ich die Persönlichkeitsrechte anderer respektiere.",
      cancelButton: "Abbrechen",
      acceptButton: "Verstanden & Fortfahren",
      oneTimeNotice: "💡 Diese Meldung erscheint nur einmal. Deine Zustimmung wird lokal gespeichert."
    },

    toasts: {
      noToiletsFound: "⚠️ Keine Toiletten in {city} gefunden",
      toiletsLoaded: "🏙️ {count} Toiletten in {city} geladen",
      error: "❌ Fehler: {message}",
      locationDetected: "📍 Standort erkannt: {city}",
      noInternet: "📡 Keine Internetverbindung. Stadt konnte nicht erkannt werden.",
      gpsPermissionDenied: "GPS-Zugriff verweigert. Bitte aktiviere die Standortberechtigung in den Einstellungen.",
      gpsError: "GPS-Standort konnte nicht ermittelt werden.",
      openSettings: "Bitte öffne die Einstellungen manuell und aktiviere GPS für RestroomAdvisor",
      settingsButton: "⚙️ Einstellungen öffnen",
      mapCentered: "📍 Karte zentriert",
      coordinatesUnavailable: "Toiletten-Koordinaten nicht verfügbar",
      acceptGuidelines: "Bitte akzeptiere die Foto-Richtlinien",
      photosUploaded: "{count} Foto(s) erfolgreich hochgeladen!",
      photoUploadError: "Fehler beim Foto-Upload. Bitte versuche es erneut.",
      noToiletSelected: "Fehler: Keine Toilette ausgewählt",
      uploadSuccess: "{count} Foto(s) erfolgreich hochgeladen!",
      uploadError: "Fehler beim Foto-Upload. Bitte versuche es erneut.",
      reviewSaved: "✅ Bewertung erfolgreich gespeichert!",
      reviewSaveError: "Fehler beim Speichern der Bewertung. Bitte versuche es erneut.",
      suggestionSuccess: "Toilette erfolgreich vorgeschlagen! Admin wurde benachrichtigt.",
      suggestionError: "Fehler beim Vorschlagen der Toilette. Bitte versuche es erneut.",
      reportSuccess: "✅ Vielen Dank für deine Meldung! Admin wurde benachrichtigt.",
      reportError: "Fehler beim Melden. Bitte versuche es erneut.",
      noAddressFound: "❌ Adresse konnte nicht gefunden werden. Bitte nutze den GPS-Button (📍 Mein Standort) oder gib eine präzisere Adresse ein.",
      locationTaken: "📍 Standort übernommen: {address}",
      coordinatesTakenNoAddress: "⚠️ Koordinaten übernommen, aber Adresse konnte nicht ermittelt werden",
      locationDetecting: "Standort wird ermittelt...",
      locationMarked: "📍 Standort markiert! Ermittle Adresse...",
      addressDetected: "✅ Adresse ermittelt: {address}",
      addressDetectionError: "⚠️ Adresse konnte nicht ermittelt werden. Bitte manuell eingeben.",
      addressDetectionFailed: "⚠️ Fehler beim Ermitteln der Adresse. Bitte manuell eingeben.",
      useCurrentLocation: "Aktuellen Standort nutzen",
      mapNotAvailable: "⚠️ Karte nicht verfügbar. Bitte Koordinaten manuell eingeben.",
      mapErrorTitle: "Karte nicht verfügbar",
      mapErrorDescription: "Bitte gib die Koordinaten manuell ein oder verwende die Adress-Suche.",
      mapRetryLoading: "🔄 Versuche Karte neu zu laden...",
      mapRetryButton: "Karte neu versuchen",
      offlineCityLoaded: "💾 Offline: Letzte Stadt \"{city}\" aus Cache geladen",
      allChangesSynced: "✅ Alle Änderungen synchronisiert!",
      offlineCacheLoaded: '💾 {count} Toiletten aus Offline-Cache geladen',
      noInternetNoCache: "⚠️ Keine Internetverbindung. Diese Stadt wurde noch nicht offline gespeichert.",
      noPermission: "🔒 Keine Berechtigung. Bitte melde dich erneut an.",
      loadError: "❌ Fehler beim Laden der Toiletten für {city}. Bitte versuche es erneut.",
      commentReportSuccess: '✅ Kommentar wurde gemeldet. Danke für deine Mithilfe!',  
      commentReportError: 'Fehler beim Melden des Kommentars.',
      backOnline: '✅ Wieder online! Deine Änderungen werden jetzt synchronisiert.',
      offlineMode: '⚠️ Keine Internetverbindung. Änderungen werden lokal gespeichert.',
      reviewNotSaved: 'Review konnte nicht gespeichert werden',
      reviewSavedOffline: '💾 Bewertung gespeichert! Wird synchronisiert sobald du online bist.',
      navigationStarted: 'Navigation zu {name} gestartet',
      adminLoginSuccess: '✅ Admin-Login erfolgreich',
      loginFailed: '❌ Login fehlgeschlagen. Bitte Zugangsdaten prüfen.',
      checkingConnection: '🔄 Verbindung wird geprüft...',
      nameTooShort: "Name muss mindestens 2 Zeichen lang sein",
      citySwitchDisabledToast: "Stadt-Wechsel-Dialog deaktiviert",
      toiletReopened: "✅ Toilette wieder geöffnet!",
      toiletReopenError: "Fehler beim Öffnen",
      photoDeleted: "✅ Foto gelöscht!",
      photoDeleteError: "Fehler beim Löschen des Fotos",
      toiletDeleted: "✅ Toilette gelöscht!",
      toiletDeleteError: "❌ Fehler beim Löschen der Toilette",
      reviewDeleted: "✅ Bewertung gelöscht!",
      reviewDeleteError: "Fehler beim Löschen der Bewertung",
      toiletUpdated: "✅ Toilette erfolgreich aktualisiert!",
      toiletUpdateError: "❌ Fehler beim Aktualisieren der Toilette"
    },

    badges: {
      newbie: "Neuling",
      bronze: "Bronze",
      silver: "Silber",
      gold: "Gold",
      platinum: "Platin",
      diamond: "Diamant",
      legend: "Legende"
    },

    achievements: {
      firstFlush: {
        name: "First Flush",
        desc: "Erste Toilette besucht"
      },
      gettingStarted: {
        name: "Getting Started",
        desc: "5 Toiletten besucht"
      },
      dedicatedUser: {
        name: "Dedicated User",
        desc: "10 Toiletten besucht"
      },
      committedExplorer: {
        name: "Committed Explorer",
        desc: "25 Toiletten besucht"
      },
      hardcoreFlusher: {
        name: "Hardcore Flusher",
        desc: "50 Toiletten besucht"
      },
      cityHopper: {
        name: "City Hopper",
        desc: "3 verschiedene Städte besucht"
      },
      countryWide: {
        name: "Country Wide",
        desc: "5 verschiedene Städte besucht"
      },
      picturePerfect: {
        name: "Picture Perfect",
        desc: "5 Fotos hochgeladen"
      },
      firstOpinion: {
        name: "First Opinion",
        desc: "Erste Bewertung geschrieben"
      },
      neighborhoodExpert: {
        name: "Neighborhood Expert",
        desc: "10 Toiletten in einer Stadt"
      },
      constructor: {
        name: "Constructor",
        desc: "Erste Toilette vorgeschlagen"
      },
      transitExplorer: {
        name: "Transit Explorer",
        desc: "5 Bahnhofs-Toiletten besucht"
      },
      secretFlusher: {
        name: "Secret Flusher",
        desc: "Check-In um 11:11 oder 22:22 Uhr"
      },
      earlyAdopter: {
        name: "Early Adopter",
        desc: "In der Launch Week dabei! 🚀"
      }
    },

    aprilFools: {
      reviewTitle: "🌟 Bewertung des Tages",
      reviewText: "\"Die beste Toilette meines Lebens. Ich habe meine Wohnung gekündigt und lebe jetzt hier. WLAN gibt es leider keins, aber dafür immer warmes Wasser. 12/10.\"",
      reviewAuthor: "— Hans M., Stammgast seit Januar",
      reviewButton: "🤔 Interessant...",
      aprilTag: "🎉 April, April!",
      southPoleOn: "🐧 Südpol: AN",
      southPoleOff: "🐧 Südpol: AUS",
      revealTitle: "April, April!",
      revealText: "Diese Bewertung war natürlich frei erfunden. 😄 Aber die Toiletten sind echt!",
      revealButton: "😄 Ha! Erwischt!",
    },
    
    common: {
      loading: "Lädt...",
      pleaseWait: "Bitte warten",
      error: "Fehler",
      success: "Erfolg",
      cancel: "Abbrechen",
      confirm: "Bestätigen",
      delete: "Löschen",
      edit: "Bearbeiten",
      save: "Speichern",
      back: "Zurück",
      next: "Weiter",
      yes: "Ja",
      no: "Nein",
      optional: "optional",
      required: "Pflichtfeld",
      confirmLeaveUnsaved: 'Möchtest du wirklich zurück? Ungespeicherte Änderungen gehen verloren.',
      anonymousUser: 'Anonymer Nutzer',
      demoUser: 'Demo Nutzer',
      sending: "Wird gesendet...",
      report: "Melden",
      characters: "Zeichen",
      tip: "Tipp:",
      pleaseSelect: "Bitte wählen...",
      withoutName: "ohne Namen"
    },

    amenities: {
      wickeltisch: "Wickeltisch",
      dusche: "Dusche",
      foehn: "Föhn",
      seife: "Seife",
      handtuecher: "Handtücher",
      spiegel: "Spiegel"
    },

    // ==================== IMPRESSUM ====================
    impressum: {
      title: 'Impressum',
      heading: 'Impressum',
      tmg: {
        title: 'Angaben gemäß § 5 TMG',
        name: 'Restroom Advisor',
        contact: 'Kontakt'
      },
      responsible: {
        title: 'Verantwortlich für den Inhalt',
        subtitle: 'Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:'
      },
      maps: {
        title: 'Kartendaten & Lizenzen',
        description: 'Die in der App verwendeten Kartendaten stammen von OpenStreetMap und unterliegen der Open Database License (ODbL).',
        mapData: 'Kartendaten',
        license: 'Lizenz',
        odbl: 'Open Database License (ODbL)'
      },
      disclaimer: {
        title: 'Haftungsausschluss',
        description: 'Die Toiletten-Informationen (Standorte, Öffnungszeiten, Bewertungen) werden von Nutzern bereitgestellt. Wir übernehmen keine Haftung für die Richtigkeit dieser Daten.',
        externalLinks: 'Für die Inhalte verlinkter externer Websites sind ausschließlich deren Betreiber verantwortlich.'
      },
      fullVersion: {
        title: 'Vollständiges Impressum',
        description: 'Alle Details, Haftungsausschluss und Streitschlichtung:'
      },
      backButton: 'Zurück zur Hauptseite'
    },

    // ==================== NUTZUNGSBEDINGUNGEN ====================
    terms: {
      title: 'Nutzungsbedingungen',
      heading: 'Nutzungsbedingungen',
      what: {
        title: 'Was ist RestroomAdvisor?',
        description: 'RestroomAdvisor ist eine kostenlose, Community-basierte App zum Finden, Bewerten und Teilen von öffentlichen Toiletten in Deutschland.',
        free: 'Kostenlos & ohne Anmeldung nutzbar'
      },
      publicFocus: {
        title: 'Öffentliche Toiletten - Unser Fokus',
        intro: 'RestroomAdvisor konzentriert sich ausschließlich auf öffentlich zugängliche Toiletten:',
        includedTitle: 'Das gehört zu unserem Angebot:',
        included1: 'Öffentliche Toiletten in Parks, Bahnhöfen, Einkaufszentren',
        included2: 'WCs in öffentlichen Gebäuden (Rathäuser, Bibliotheken, etc.)',
        included3: 'City-Toiletten und Sanitäranlagen auf öffentlichen Plätzen',
        included4: 'Toiletten an Autobahnraststätten und Tankstellen',
        included5: 'Behindertengerechte öffentliche Toiletten',
        excludedTitle: 'Das gehört NICHT zu unserem Angebot:',
        excluded1: 'Toiletten in Restaurants, Cafés oder Bars',
        excluded2: 'WCs in Geschäften, die nur für Kunden gedacht sind',
        excluded3: 'Private oder kommerzielle Einrichtungen ohne öffentlichen Zugang',
        excluded4: 'Toiletten, die einen Konsumzwang voraussetzen',
        exceptionsTitle: 'Ausnahmen',
        exceptionsText: 'Wenn ein Restaurant oder Geschäft seine Toilette ausdrücklich als öffentlich zugänglich kennzeichnet (z.B. "Nette Toilette"-Programm), kann sie hinzugefügt werden. Bitte im Kommentar vermerken!'
      },
      allowed: {
        title: 'Das ist erlaubt',
        subtitle: 'Du darfst:',
        item1: 'Korrekte Informationen über Toiletten teilen',
        item2: 'Ehrliche Bewertungen schreiben',
        item3: 'Fotos von Toiletten-Räumen hochladen (ohne Personen)',
        item4: 'Geschlossene Toiletten melden',
        item5: 'Neue Toiletten vorschlagen'
      },
      forbidden: {
        title: 'Das ist NICHT erlaubt',
        subtitle: 'Verboten sind:',
        item1: 'Beleidigungen, Hassrede, Diskriminierung',
        item2: 'Spam oder Werbung',
        item3: 'Falsche oder irreführende Informationen',
        item4: 'Fotos mit erkennbaren Personen',
        item5: 'Illegale oder unangemessene Inhalte',
        consequences: 'Konsequenzen:',
        consequencesText: 'Beiträge werden abgelehnt oder gelöscht'
      },
      photos: {
        title: 'Foto-Upload-Regeln',
        subtitle: 'Wichtig beim Hochladen:',
        rule2: 'Keine Kennzeichen sichtbar',
        rule3: 'Nur Toiletten-Räume und Einrichtung',
        rule4: 'Du bist Urheber des Fotos',
        moderation: 'Alle Fotos werden von unserem Admin-Team geprüft'
      },
      disclaimer: {
        title: 'Haftungsausschluss',
        description: 'Die meisten Toiletten-Informationen werden von Nutzern bereitgestellt.',
        noGuarantee: 'Wir übernehmen keine Garantie für die Richtigkeit, Vollständigkeit oder Aktualität der Daten'
      },
      rights: {
        title: 'Löschung & Änderung',
        description: 'Du kannst jederzeit die Löschung deiner Bewertungen und Fotos verlangen.',
        contact: 'Kontakt'
      },
      fullVersion: {
        title: 'Vollständige Nutzungsbedingungen',
        description: 'Alle Details zu Rechten, Pflichten und rechtlichen Hinweisen:'
      },
      backButton: 'Zurück zur Hauptseite'
    },

    photoRules: 'Keine Personen fotografieren',

    // ==================== DATENSCHUTZ ====================
    privacy: {
      title: 'Datenschutzerklärung',
      heading: 'Datenschutzerklärung',
      localStorage: {
        title: 'Lokal auf deinem Gerät',
        description: 'Dein Name, besuchte Toiletten, Bewertungen und Check-ins werden nur auf deinem Gerät gespeichert (localStorage).',
        notTransferred: 'Diese Daten werden nicht an uns übertragen'
      },
      firebase: {
        title: 'In unserer Datenbank (Firebase)',
        description: 'Toiletten-Vorschläge, Bewertungen (Name, Sterne, Kommentar) und hochgeladene Fotos werden auf Firebase (Google, EU-Server) gespeichert.',
        moderated: 'Alle Beiträge werden vor Veröffentlichung geprüft',
        retention: 'Speicherdauer: Bewertungen & Fotos unbegrenzt, Schließmeldungen 30 Tage'
      },
      gps: {
        title: 'GPS-Standort',
        description: 'Wenn du die GPS-Funktion nutzt, wird dein Standort einmalig abgerufen, um die nächste Stadt zu finden.',
        notStored: 'Wird nicht gespeichert oder übertragen'
      },
      photos: {
        title: 'Fotos & Persönlichkeitsrechte',
        description: 'Beim Foto-Upload bestätigst du, dass keine Personen erkennbar sind und du die Persönlichkeitsrechte beachtest.',
        adminCheck: 'Fotos werden von unserem Admin-Team geprüft'
      },
      gdpr: {
        title: 'Deine Rechte (DSGVO)',
        description: 'Du hast jederzeit das Recht auf Auskunft, Berichtigung, Löschung und Widerspruch.',
        contact: 'Kontakt',
        legalBasis: 'Rechtsgrundlage',
        legalBasisText: 'DSGVO Art. 6 Abs. 1 (Einwilligung & berechtigtes Interesse)',
        revocation: 'Widerruf',
        revocationText: 'Du kannst deine Einwilligung jederzeit widerrufen'
      },
      cookies: {
        title: 'Keine Cookies & kein Tracking',
        description: 'Wir verwenden keine Cookies und kein Tracking. Deine Daten bleiben privat.'
      },
      thirdParty: {
        title: 'Weitergabe an Dritte',
        description: 'Wir geben deine Daten nicht an Dritte weiter, außer Firebase (Google) als technischer Dienstleister.'
      },
      complaints: {
        title: 'Beschwerderecht bei Aufsichtsbehörde',
        description: 'Du hast das Recht, dich bei einer Datenschutz-Aufsichtsbehörde zu beschweren.',
        authority: 'Landesbeauftragte für Datenschutz NRW',
        email: 'poststelle@ldi.nrw.de',
        phone: '0211/38424-0'
      },
      osmAttribution: {
        title: 'Kartendaten & Lizenzen',
        description: 'Die in der App verwendeten Kartendaten stammen von OpenStreetMap und sind lizenziert unter der Open Database License (ODbL).',
        mapData: 'Kartendaten',
        contributors: '© OpenStreetMap contributors',
        moreInfo: 'Mehr Informationen:'
      },
      fullVersion: {
        title: 'Vollständige Datenschutzerklärung',
        description: 'Alle Details und Pflichtinformationen findest du hier:'
      },
      backButton: 'Zurück zur Hauptseite'
    }
  },
  
  en: {
    welcome: {
      title: "Welcome to Restroom Advisor!",
      subtitle: "Find the best public restrooms in your city",
      nameLabel: "Your Name",
      namePlaceholder: "e.g. John Doe",
      startButton: "Let's go!",
      cityLabel: "Which city are you in?",
      cityPlaceholder: "e.g. Berlin, London, New York",
      locationButton: "Use my location",
      locationDetecting: "Detecting location...",
      orDivider: "or",
      minCharsHint: "💡 Type at least 3 letters for suggestions",
      noCitiesFound: "No cities found for",
      tryDifferentSpelling: "Try a different spelling",
      impressum: "Imprint",
      datenschutz: "Privacy Policy",
      nutzungsbedingungen: "Terms of Service",
      charactersCount: '{count}/30 characters', 
      adminLogin: '🔐 Admin Login', 
      adminEmail: 'Admin Email',  
      adminPassword: 'Admin Password', 
      adminLoginButton: 'Admin Login',  
      cancel: 'Cancel',
      nameStoredLocally: 'Your name will be stored locally on your device',
      guestButton: 'Continue as Guest'
    },

    languageSelection: {
      title: "Choose Language",
      subtitle: "Sprache wählen",
      german: "German",
      english: "English",
      infoText: "You can change the language later in your profile."
    },
    
// App Download Screen (Web-Only)
    appDownload: {
      title: "Restroom Advisor",
      androidOnly: "Only for Android",
      description: "Download the official Restroom Advisor app and experience all features with improved performance!",
      benefit1Title: "Your data stays on your device",
      benefit1Text: "Name, reviews and check-ins stored locally only",
      benefit2Title: "Offline Functionality",
      benefit2Text: "Use the app even without internet connection",
      benefit3Title: "Better Performance",
      benefit3Text: "Faster loading times and smoother operation",
      downloadButton: "Download on Play Store",
      continueWeb: "Continue with web version"
    },
    
    main: {
      searchToilet: "🚽 Restroom",
      searchCity: "🏙️ City",
      infoBadgeOf: "of",
      infoBadgeShown: "restrooms shown",
      infoBadgeMove: "Move the map for more",
      filterAccessible: "♿ Access",
      filterFree: "💰 Free",
      toiletsFound: "restrooms found",
      toiletsFoundSingular: "restroom found",
      toiletsFoundPlural: "restrooms found",
      results: "results",
      resultsFor: "result for",
      resultsForPlural: "results for",
      of: "of",
      gesamt: "total",
      total: "total",
      sichtbar: "visible",
      imSichtbarenBereich: "in visible area",
      navMap: "Map",
      navList: "List",
      navSuggest: "Suggest",
      navProfile: "Profile",
      searchCityPlaceholder: "🏙️ Search city...",
      searchToiletPlaceholder: "🚽 Search restroom..."
    },

    listView: {
      closed: "Closed",
      suggestion: "Suggestion",
      timesReported: "x reported",
      open: "Open",
      review: "review",
      reviews: "reviews",
      lastVisited: "Last visited:",
      free: "Free",
      paid: "Paid",
      accessible: "Accessible"
    },

    suggest: {
      title: "Suggest Restroom",
      infoText: "Your suggestion will appear in the list and be visible to everyone.",
      editingInfo: "You are editing an existing restroom. Changes will be applied immediately.",
      mandatoryFields: "Required information",
      nameLabel: "Restroom Name",
      namePlaceholder: "e.g. City Toilet Main Station",
      selectPhoto: "Select Photo",
      addressLabel: "Address",
      addressPlaceholder: "Type at least 3 characters for suggestions...",
      addressHint: "Type at least 3 characters for suggestions",
      addressTips: "Tips: Type the complete street name",
      addressExample: "e.g. \"Main Street\" instead of \"Main St\"",
      searchingAddresses: "Searching addresses...",
      noAddressesFound: "No addresses found for \"{query}\"",
      useCurrentLocation: "Use my location",
      selectOnMap: "Select on map",
      selectedLocation: "Location selected",
      tapToSelect: "Tap on the map to mark the location",
      markerCanBeMoved: "The marker can be moved by tapping again",
      costLabel: "Cost",
      costFree: "Free",
      costPaid: "Paid",
      costAmount: "Price (e.g. €0.50)",
      costAmountPlaceholder: "e.g. €0.50",
      accessibilityLabel: "Accessible?",
      accessibilityYes: "Yes",
      accessibilityNo: "No",
      accessibilityUnknown: "Unknown",
      openingHoursLabel: "Opening Hours (optional)",
      openingHoursPlaceholder: "e.g. Mon-Fri 8am-6pm",
      amenitiesLabel: "Amenities (optional)",
      photosLabel: "Add Photos (optional)",
      uploadPhotos: "Upload photos",
      uploadHint: "Click here or drag images",
      photosSelected: "photo(s) selected",
      submitButton: "Submit suggestion",
      editButton: "Save changes",
      editRestroom: "Edit restroom",
      mapTip: "Click on the map to mark the exact location. The address will be determined automatically and can be adjusted if needed.",
      newLocation: "New location",
      detectingLocation: "Detecting location...",
      additionalRequired: "Additional Required Info",
      additionalInfo: "Additional Information",
      initialReview: "Initial Review",
      validation: {
      requiredFields: "Please provide name, address (or location on map) and cost!",
      priceRequired: "Please provide price!",
      confirmDifferentCity: "⚠️ Warning: The marked location is in \"{sCity}\", but you selected \"{city}\" as city.\n\nDo you want to continue anyway?\n\nThe restroom will be saved in \"{sCity}\"."
      }
    },

    review: {
      title: "Rate or upload photo",
      editTitle: "Edit review",
      commentLabel: "Your comment",
      commentPlaceholder: "Share your experience... (optional)",
      charactersCount: "{count} characters",
      addPhotos: "Add photos",
      importantReminder: "Important reminder",
      photoReminderText: "Please only photograph restroom facilities. No people should be visible in photos (not even in the background or mirrors).",
      uploadPhotos: "Upload photos",
      uploadHint: "Click here or drag images",
      photosSelected: "{count} photo(s) selected",
      confirmationText: "✅ By submitting you confirm that your photos comply with the photo guidelines and show no people.",
      submitDisabled: "Please rate or upload photos",
      pleaseRateOrUpload: "Please rate or upload photos",
      submitPhotosOnly: "Upload {count} photo(s)",
      submitReview: "Submit review",
      updateReview: "Update review",
      rateYourVisit: "How was your visit?",
      tapToRate: "Tap the stars to rate",
      veryBad: "Very bad",
      bad: "Bad",
      okay: "Okay",
      good: "Good",
      excellent: "Excellent!"
    },

    validation: {
      allowedCharsComment: "✓ Allowed: Letters, numbers, emojis, punctuation",
      maxCharacters: "✓ Max. {count} characters",
      charactersRemaining: "{current}/{max} characters"
    },

    reportClosure: {
      title: "Report change",
      selectCategory: "Select category",
      selectReason: "Select reason",
      additionalInfo: "Additional information (optional)",
      additionalInfoPlaceholder: "e.g. When did you notice the change?",
      addPhotos: "Add photos (optional)",
      photoProofHelp: "Photos can serve as proof for your report",
      uploadPhotos: "Upload photos",
      uploadHint: "Click here or drag images",
      photosSelected: "{count} photo(s) selected",
      submitReport: "Submit report",
      infoMessage: "ℹ️ Your report helps the community. It will be reviewed by the admin team.",
      selectCategoryError: "Please select a category!",
      selectReasonError: "Please select a reason!",
      categories: {
        closed: "🔒 Closed",
        address: "📍 Wrong address",
        hours: "🕐 Wrong opening hours",
        accessibility: "♿ Accessibility incorrect",
        cost: "💶 Cost incorrect",
        other: "📝 Other"
      },
      reasons: {
        closed: {
          temporary: "Temporarily closed",
          permanent: "Permanently closed",
          notFound: "Not found",
          renovation: "Under renovation",
          other: "Other"
        },
        address: {
          wrong: "Address wrong",
          entrance: "Entrance elsewhere",
          notExists: "Building does not exist",
          other: "Other"
        },
        hours: {
          wrong: "Opening hours wrong",
          different: "Different opening hours",
          alwaysOpen: "Always open",
          alwaysClosed: "Always closed",
          other: "Other"
        },
        accessibility: {
          notAccessible: "Not accessible",
          accessible: "Accessible",
          wheelchairAccessible: "Wheelchair accessible",
          other: "Other"
        },
        cost: {
          wrongAmount: "Wrong amount",
          freeInsteadPaid: "Free instead of paid",
          paidInsteadFree: "Paid instead of free",
          other: "Other"
        },
        other: {
          inappropriatePhoto: "Inappropriate photo",
          wrongName: "Wrong name",
          other: "Other"
        }
      }
    },

    reportComment: {
      title: "Report Comment",
      commentBy: "Comment by",
      noText: "No text",
      selectReason: "Why are you reporting this comment?",
      reasons: {
        hate: "Insult / Hate Speech",
        spam: "Spam / Advertising",
        misinformation: "Misinformation",
        inappropriate: "Inappropriate Content",
        other: "Other"
      },
      warningText: "False reports may lead to suspension."
    },
    
    detail: {
      details: "Details",
      closed: "This restroom is closed",
      reason: "Reason",
      until: "Expected until",
      closedAt: "Closed on",
      suggested: "Suggested restroom",
      suggestedBy: "Suggested by",
      waitingForApproval: "Waiting for approval",
      timesReported: "x reported",
      address: "Address",
      city: "City",
      cost: "Cost",
      free: "Free",
      paid: "Paid",
      accessibility: "Accessibility",
      accessible: "Accessible",
      notAccessible: "Not accessible",
      openingHours: "Opening hours",
      nowOpen: "Now open",
      currentlyClosed: "Currently closed",
      amenities: "Amenities",
      lastVisited: "Last visited",
      reviews: "Reviews",
      noReviews: "No reviews yet. Be the first!",
      rateButton: "Rate or upload photo",
      editReview: "Edit review",
      reportChange: "Report change",
      showOnMap: "Show on map",
      navigation: "Navigation",
      addReview: "Add review", 
      comment: "Comment", 
      uploadPhoto: "Upload photos", 
      yes: "Yes",
      no: "No",
      startNavigation: "Start navigation",
      showDetails: "Show details",
      navigationModal: {
        title: "Start navigation",
        externalAppRequired: "External app required",
        description: "You will be redirected to an external navigation app (e.g. Google Maps, Apple Maps etc.).",
        reminder: "Make sure you have a navigation app installed to start the route.",
        dontShowAgain: "Don't show this message again",
        cancel: "Cancel",
      startNavigation: "Start navigation"
      },
      notSpecified: "Not specified",
      reportedClosedTimes: "This restroom was reported closed {count} times",
      lastReport: "Last report:"
    },
    
    profile: {
      myProfile: "My Profile",
      memberSince: "Member since",
      level: "Level",
      toiletsUntilNext: "restrooms until next level",
      maxLevel: "Max level reached!",
      different: "Different",
      checkIns: "Check-ins",
      visitedToilets: "Visited Restrooms",
      noVisits: "No restrooms visited yet",
      timesVisited: "x visited",
      achievements: "Achievements",
      achievementsUnlocked: "unlocked",
      secret: "SECRET",
      adminDashboard: "Admin Dashboard",
      saveButton: "Save",
      successSaved: "Name successfully changed!",
      nameTooShort: "Name must be at least 2 characters",
      dangerZone: "Danger Zone",
      resetWarning: "Reset the app to initial state. All your data (name, check-ins, reviews) will be permanently deleted.",
      resetButton: "Reset app completely",
      resetConfirm1: "REALLY DELETE EVERYTHING?",
      resetConfirm2: "LAST WARNING!",
      resetSuccess: "App has been reset!",
      languageSettings: "Language Settings",
      currentLanguage: "Current Language",
      changeLanguage: "Change Language",
      editProfile: "Edit Profile",
      yourName: "Your Name",
      yourNamePlaceholder: "Your Name",
      characters: "characters",
      language: "Language",
      tapToChangeLanguage: "Tap to change language",
      visitedToiletAlt: "Preview image of visited restroom",
      changeNameButton: "Change name",
      nameChangeSuccess: "✅ Name successfully changed!",
      nameMinLength: "Name must be at least 2 characters",
      dangerZoneTitle: "⚠️ Danger Zone",
      resetDescription: "Reset the app to initial state. <strong>All your data</strong> (name, check-ins, reviews) will be <strong>permanently deleted</strong>.",
      resetButtonText: "Reset app completely",
      resetConfirmTitle1: "⚠️ REALLY DELETE EVERYTHING?",
      resetConfirmItems: "This will delete:\n• Your name\n• All check-ins\n• All reviews\n• All local data\n\nThis action CANNOT be undone!",
      resetConfirmTitle2: "🚨 LAST WARNING!",
      resetConfirmFinal: "Are you 100% sure?\n\nClick OK to delete EVERYTHING.",
      resetSuccessMessage: "✅ App has been reset!",
      citySwitchDisabled: "You have disabled the automatic city switch dialog.",
      reEnableCitySwitchButton: "Re-enable city switch dialog",
      citySwitchReenabled: "✅ City switch dialog re-enabled!",
      selectRank: "Select Your Rank",
      currentRank: "Current Rank",
      checkInRanks: "Check-In Ranks",
      reviewRanks: "Review Ranks",
      achievementRanks: "Achievement Ranks",
      specialRanks: "Special Ranks",
      rankChanged: "✅ Rank changed!",
      changeRank: "Change"
    },

    achievementPopup: {
      unlocked: "🏆 Achievement Unlocked!",
      viewAll: "📊 View All Achievements"
    },

    loading: {
      title: "Loading...",
      pleaseWait: "Please wait"
    },

    netiquette: {
      title: "Photo Guidelines",
      importantNotice: "ℹ️ Important: All uploaded photos are reviewed individually",
      importantDescription: "Our admin team reviews each contribution before publication to ensure quality and compliance with guidelines.",
      rulesHeading: "Please follow these rules when uploading photos:",
      noPeople: "No People in Photos",
      noPeopleDesc: "<strong>No persons</strong> may be visible in the photos. Make sure no people are visible in the background, in mirrors, or otherwise.",
      privacyRights: "Respect Privacy Rights",
      privacyRightsDesc: "Respect the privacy of others. No photos of people using the restroom or in private moments.",
      onlyFacilities: "Only Photograph Restroom Facilities",
      onlyFacilitiesDesc: "Photograph only the restroom facilities, sinks, cleanliness and amenities. Show what the restroom looks like and how it is equipped.",
      confirmText: "<strong>I have read and understood the photo guidelines.</strong> I confirm that no people are visible in my photos and that I respect the privacy rights of others.",
      cancelButton: "Cancel",
      acceptButton: "Understood & Continue",
      oneTimeNotice: "💡 This message appears only once. Your consent is saved locally."
    },

    toasts: {
      noToiletsFound: "⚠️ No restrooms found in {city}",
      toiletsLoaded: "🏙️ {count} restrooms loaded in {city}",
      error: "❌ Error: {message}",
      locationDetected: "📍 Location detected: {city}",
      noInternet: "📡 No internet connection. Could not detect city.",
      gpsPermissionDenied: "GPS access denied. Please enable location permission in settings.",
      gpsError: "Could not determine GPS location.",
      openSettings: "Please open settings manually and enable GPS for RestroomAdvisor",
      settingsButton: "⚙️ Open Settings",
      mapCentered: "📍 Map centered",
      coordinatesUnavailable: "Restroom coordinates unavailable",
      acceptGuidelines: "Please accept the photo guidelines",
      photosUploaded: "{count} photo(s) successfully uploaded!",
      photoUploadError: "Error uploading photo. Please try again.",
      noToiletSelected: "Error: No restroom selected",
      uploadSuccess: "{count} photo(s) successfully uploaded!",
      uploadError: "Error uploading photo. Please try again.",
      reviewSaved: "✅ Review successfully saved!",
      reviewSaveError: "Error saving review. Please try again.",
      suggestionSuccess: "Restroom successfully suggested! Admin has been notified.",
      suggestionError: "Error suggesting restroom. Please try again.",
      reportSuccess: "✅ Thank you for your report! Admin has been notified.",
      reportError: "Error submitting report. Please try again.",
      noAddressFound: "❌ Address not found. Please use GPS button (📍 My Location) or enter a more precise address.",
      locationTaken: "📍 Location taken: {address}",
      coordinatesTakenNoAddress: "⚠️ Coordinates taken, but address could not be determined",
      locationDetecting: "Detecting location...",
      locationMarked: "📍 Location marked! Detecting address...",
      addressDetected: "✅ Address detected: {address}",
      addressDetectionError: "⚠️ Address could not be determined. Please enter manually.",
      addressDetectionFailed: "⚠️ Error detecting address. Please enter manually.",
      useCurrentLocation: "Use current location",
      mapNotAvailable: "⚠️ Map not available. Please enter coordinates manually.",
      mapErrorTitle: "Map not available",
      mapErrorDescription: "Please enter coordinates manually or use address search.",
      mapRetryLoading: "🔄 Trying to reload map...",
      mapRetryButton: "Retry map",
      offlineCityLoaded: "💾 Offline: Last city \"{city}\" loaded from cache",
      allChangesSynced: "✅ All changes synchronized!",
      offlineCacheLoaded: '💾 {count} restrooms loaded from offline cache',
      noInternetNoCache: "⚠️ No internet connection. This city has not been cached offline yet.",
      noPermission: "🔒 No permission. Please sign in again.",
      loadError: "❌ Error loading restrooms for {city}. Please try again.",
      commentReportSuccess: '✅ Comment has been reported. Thank you for your help!', 
      commentReportError: 'Error reporting the comment.',
      backOnline: '✅ Back online! Your changes are now being synchronized.',
      offlineMode: '⚠️ No internet connection. Changes will be saved locally.',
      reviewNotSaved: 'Review could not be saved',
      reviewSavedOffline: '💾 Review saved! Will sync when you are back online.',
      navigationStarted: 'Navigation to {name} started',
      adminLoginSuccess: '✅ Admin login successful',
      loginFailed: '❌ Login failed. Please check your credentials.',
      checkingConnection: '🔄 Checking connection...',
      nameTooShort: "Name must be at least 2 characters long",
      citySwitchDisabledToast: "City switch dialog disabled",
      toiletReopened: "✅ Toilet reopened!",
      toiletReopenError: "Error reopening toilet",
      photoDeleted: "✅ Photo deleted!",
      photoDeleteError: "Error deleting photo",
      toiletDeleted: "✅ Toilet deleted!",
      toiletDeleteError: "❌ Error deleting toilet",
      reviewDeleted: "✅ Review deleted!",
      reviewDeleteError: "Error deleting review",
      toiletUpdated: "✅ Toilet successfully updated!",
      toiletUpdateError: "❌ Error updating toilet"
    },

    badges: {
      newbie: "Newbie",
      bronze: "Bronze",
      silver: "Silver",
      gold: "Gold",
      platinum: "Platinum",
      diamond: "Diamond",
      legend: "Legend"
    },

    achievements: {
      firstFlush: {
        name: "First Flush",
        desc: "Visited first restroom"
      },
      gettingStarted: {
        name: "Getting Started",
        desc: "Visited 5 restrooms"
      },
      dedicatedUser: {
        name: "Dedicated User",
        desc: "Visited 10 restrooms"
      },
      committedExplorer: {
        name: "Committed Explorer",
        desc: "Visited 25 restrooms"
      },
      hardcoreFlusher: {
        name: "Hardcore Flusher",
        desc: "Visited 50 restrooms"
      },
      cityHopper: {
        name: "City Hopper",
        desc: "Visited 3 different cities"
      },
      countryWide: {
        name: "Country Wide",
        desc: "Visited 5 different cities"
      },
      picturePerfect: {
        name: "Picture Perfect",
        desc: "Uploaded 5 photos"
      },
      firstOpinion: {
        name: "First Opinion",
        desc: "Written first review"
      },
      neighborhoodExpert: {
        name: "Neighborhood Expert",
        desc: "10 restrooms in one city"
      },
      constructor: {
        name: "Constructor",
        desc: "Suggested first restroom"
      },
      transitExplorer: {
        name: "Transit Explorer",
        desc: "Visited 5 train station restrooms"
      },
      secretFlusher: {
        name: "Secret Flusher",
        desc: "Check-in at 11:11 or 22:22"
      },
      earlyAdopter: {
        name: "Early Adopter",
        desc: "Part of the launch week! 🚀"
      }
    },

    aprilFools: {
      reviewTitle: "🌟 Review of the Day",
      reviewText: "\"Best restroom of my life. I cancelled my apartment and now live here. No WiFi unfortunately, but always hot water. 12/10.\"",
      reviewAuthor: "— Hans M., regular since January",
      reviewButton: "🤔 Interesting...",
      aprilTag: "🎉 April Fools!",
      southPoleOn: "🐧 South Pole: ON",
      southPoleOff: "🐧 South Pole: OFF",
      revealTitle: "April Fools!",
      revealText: "That review was completely made up. 😄 But the restrooms are real!",
      revealButton: "😄 Ha! Got me!",
    },
    
    common: {
      loading: "Loading...",
      pleaseWait: "Please wait",
      error: "Error",
      success: "Success",
      cancel: "Cancel",
      confirm: "Confirm",
      delete: "Delete",
      edit: "Edit",
      save: "Save",
      back: "Back",
      next: "Next",
      yes: "Yes",
      no: "No",
      optional: "Optional",
      required: "required",
      confirmLeaveUnsaved: 'Do you really want to go back? Unsaved changes will be lost.',
      anonymousUser: 'Anonymous User',
      demoUser: 'Demo User',
      sending: "Sending...",
      report: "Report",
      characters: "characters",
      tip: "Tip:",
      pleaseSelect: "Please select...",
      withoutName: "without name"
    },
    
    amenities: {
      wickeltisch: "Changing table",
      dusche: "Shower",
      foehn: "Hair dryer",
      seife: "Soap",
      handtuecher: "Towels",
      spiegel: "Mirror"
    },

    // ==================== IMPRESSUM ====================
    impressum: {
      title: 'Legal Notice',
      heading: 'Legal Notice',
      tmg: {
        title: 'Information according to § 5 TMG',
        name: 'Restroom Advisor',
        contact: 'Contact'
      },
      responsible: {
        title: 'Responsible for Content',
        subtitle: 'Responsible for content according to § 55 Abs. 2 RStV:'
      },
      maps: {
        title: 'Map Data & Licenses',
        description: 'The map data used in the app is provided by OpenStreetMap and is subject to the Open Database License (ODbL).',
        mapData: 'Map data',
        license: 'License',
        odbl: 'Open Database License (ODbL)'
      },
      disclaimer: {
        title: 'Disclaimer',
        description: 'Restroom information (locations, opening hours, reviews) is provided by users. We assume no liability for the accuracy of this data.',
        externalLinks: 'The operators of linked external websites are solely responsible for their content.'
      },
      fullVersion: {
        title: 'Complete Legal Notice',
        description: 'All details, disclaimer and dispute resolution:'
      },
      backButton: 'Back to Main Page'
    },

    // ==================== TERMS OF USE ====================
    terms: {
      title: 'Terms of Use',
      heading: 'Terms of Use',
      what: {
        title: 'What is RestroomAdvisor?',
        description: 'RestroomAdvisor is a free, community-based app for finding, rating and sharing public restrooms in Germany.',
        free: 'Free to use without registration'
      },
      publicFocus: {
        title: 'Public Restrooms - Our Focus',
        intro: 'RestroomAdvisor focuses exclusively on publicly accessible restrooms:',
        includedTitle: 'What we include:',
        included1: 'Public restrooms in parks, train stations, shopping centers',
        included2: 'Restrooms in public buildings (city halls, libraries, etc.)',
        included3: 'City toilets and sanitary facilities in public places',
        included4: 'Restrooms at highway rest stops and gas stations',
        included5: 'Accessible public restrooms',
        excludedTitle: 'What we do NOT include:',
        excluded1: 'Restrooms in restaurants, cafés or bars',
        excluded2: 'Restrooms in stores that are only for customers',
        excluded3: 'Private or commercial facilities without public access',
        excluded4: 'Restrooms that require consumption',
        exceptionsTitle: 'Exceptions',
        exceptionsText: 'If a restaurant or store explicitly marks its restroom as publicly accessible (e.g. "Nice Toilet" program), it can be added. Please note in the comment!'
      },
      allowed: {
        title: 'What is allowed',
        subtitle: 'You may:',
        item1: 'Share correct information about restrooms',
        item2: 'Write honest reviews',
        item3: 'Upload photos of restroom facilities (without people)',
        item4: 'Report closed restrooms',
        item5: 'Suggest new restrooms'
      },
      forbidden: {
        title: 'What is NOT allowed',
        subtitle: 'Prohibited:',
        item1: 'Insults, hate speech, discrimination',
        item2: 'Spam or advertising',
        item3: 'False or misleading information',
        item4: 'Photos with identifiable people',
        item5: 'Illegal or inappropriate content',
        consequences: 'Consequences:',
        consequencesText: 'Contributions will be rejected or deleted'
      },
      photos: {
        title: 'Photo Upload Rules',
        subtitle: 'Important when uploading:',
        rule2: 'No license plates visible',
        rule3: 'Only restroom facilities and equipment',
        rule4: 'You are the author of the photo',
        moderation: 'All photos are reviewed by our admin team'
      },
      disclaimer: {
        title: 'Disclaimer',
        description: 'Most restroom information is provided by users.',
        noGuarantee: 'We assume no guarantee for the accuracy, completeness or timeliness of the data'
      },
      rights: {
        title: 'Deletion & Changes',
        description: 'You can request the deletion of your reviews and photos at any time.',
        contact: 'Contact'
      },
      fullVersion: {
        title: 'Complete Terms of Use',
        description: 'All details on rights, obligations and legal notices:'
      },
      backButton: 'Back to Main Page'
    },

    photoRules: 'No photographing people',

    // ==================== PRIVACY POLICY ====================
    privacy: {
      title: 'Privacy Policy',
      heading: 'Privacy Policy',
      localStorage: {
        title: 'Locally on Your Device',
        description: 'Your name, visited restrooms, reviews and check-ins are only stored on your device (localStorage).',
        notTransferred: 'This data is not transferred to us'
      },
      firebase: {
        title: 'In Our Database (Firebase)',
        description: 'Restroom suggestions, reviews (name, stars, comment) and uploaded photos are stored on Firebase (Google, EU servers).',
        moderated: 'All contributions are reviewed before publication',
        retention: 'Storage duration: Reviews & photos unlimited, closure reports 30 days'
      },
      gps: {
        title: 'GPS Location',
        description: 'When you use the GPS function, your location is retrieved once to find the nearest city.',
        notStored: 'Not stored or transmitted'
      },
      photos: {
        title: 'Photos & Privacy Rights',
        description: 'When uploading photos, you confirm that no people are recognizable and that you respect privacy rights.',
        adminCheck: 'Photos are reviewed by our admin team'
      },
      gdpr: {
        title: 'Your Rights (GDPR)',
        description: 'You have the right to information, correction, deletion and objection at any time.',
        contact: 'Contact',
        legalBasis: 'Legal basis',
        legalBasisText: 'GDPR Art. 6 Para. 1 (consent & legitimate interest)',
        revocation: 'Revocation',
        revocationText: 'You can revoke your consent at any time'
      },
      cookies: {
        title: 'No Cookies & No Tracking',
        description: 'We do not use cookies or tracking. Your data remains private.'
      },
      thirdParty: {
        title: 'Disclosure to Third Parties',
        description: 'We do not disclose your data to third parties, except Firebase (Google) as a technical service provider.'
      },
      complaints: {
        title: 'Right to Complain to Supervisory Authority',
        description: 'You have the right to complain to a data protection supervisory authority.',
        authority: 'State Commissioner for Data Protection NRW',
        email: 'poststelle@ldi.nrw.de',
        phone: '0211/38424-0'
      },
      osmAttribution: {
        title: 'Map Data & Licenses',
        description: 'The map data used in the app is provided by OpenStreetMap and is licensed under the Open Database License (ODbL).',
        mapData: 'Map data',
        contributors: '© OpenStreetMap contributors',
        moreInfo: 'More information:'
      },
      fullVersion: {
        title: 'Complete Privacy Policy',
        description: 'All details and mandatory information can be found here:'
      },
      backButton: 'Back to Main Page'
    }
  }
};

// Helper-Funktionen
export const getCurrentLanguage = () => {
  return localStorage.getItem('restroomadvisor_language') || null;
};

export const setLanguage = (lang) => {
  localStorage.setItem('restroomadvisor_language', lang);
  localStorage.setItem('restroomadvisor_language_set', 'true');
};

export const hasLanguageBeenSet = () => {
  return localStorage.getItem('restroomadvisor_language_set') === 'true';
};

export const translate = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang || getCurrentLanguage() || 'de'];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};

export const t = (key, lang = getCurrentLanguage() || 'de') => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};

export default translations;

export const availableAmenities = [
  'Wickeltisch',
  'Dusche',
  'Föhn',
  'Seife',
  'Handtücher',
  'Spiegel'
];

export const amenityKeyMap = {
  'Wickeltisch': 'wickeltisch',
  'Dusche': 'dusche',
  'Föhn': 'foehn',
  'Seife': 'seife',
  'Handtücher': 'handtuecher',
  'Spiegel': 'spiegel',
  'Changing table': 'wickeltisch',
  'Shower': 'dusche',
  'Hair dryer': 'foehn',
  'Soap': 'seife',
  'Towels': 'handtuecher',
  'Mirror': 'spiegel'
};

export const translateAmenity = (amenity, lang) => {
  const key = amenityKeyMap[amenity];
  if (!key) {
    console.warn(`⚠️ Unbekannte Amenity: "${amenity}"`);
    return amenity; 
  }
  return translate(lang, `amenities.${key}`);
};